export enum ApiStreamEventType {
    Step = "step",
    Retrieval = "retrieval",
    ThinkingStart = "thinking_start",
    ThinkingDelta = "thinking_delta",
    ThinkingStop = "thinking_stop",
    LlmStart = "llm_start",
    LlmStop = "llm_stop",
    ReferencesStart = "references_start",
    ReferencesDelta = "references_delta",
    ReferencesStop = "references_stop",
    ContentBlockStart = "content_block_start",
    ContentBlockDelta = "content_block_delta",
    ContentBlockStop = "content_block_stop",
    ToolCallStart = "tool_call_start",
    ToolCallDelta = "tool_call_delta",
    ToolCallStop = "tool_call_stop",
    ToolResult = "tool_result",
    /** The sections a tool read, admitted for the caller, named per call (Marvin Explore lights them;
     *  the web reads the same list folded into the activity part, so this frame draws nothing). */
    ToolTouched = "tool_touched",
    ToolSuggestion = "tool_suggestion",
    ArtifactReady = "artifact_ready",
    AskUser = "ask_user",
    AskUserAnswered = "ask_user_answered",
    ActionProposed = "action_proposed",
    ActionResolved = "action_resolved",
    MemoryUpdated = "memory_updated",
    NavigationSuggested = "navigation_suggested",
    ContextStats = "context_stats",
    PartCreated = "part_created",
    PartUpdated = "part_updated",
    PartCompleted = "part_completed",
    RunStatus = "run_status",
    MessageJoined = "message_joined",
    Done = "done",
    Error = "error",
}
